import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';

import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { DataService } from 'src/app/shared/network/data.service';
import { ProjectService } from 'src/app/shared/project/project.service';
import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { ExistenceSettings } from '../../../shared/import/existence-settings';
import { ImportStep } from '../../import-step';
import { ColumnScrollService } from '../../column-scroll.service';

@Component({
    selector: 'new-lost-column-selection',
    templateUrl: './new-lost-column-selection.component.html',
    styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class NewLostColumnSelectComponent extends BaseColumnSelectComponent implements OnInit {
    readonly step = ImportStep.NewLost;
    projectId: string;
    columns: ColumnForSelection[];
    selectedColumn: ColumnForSelection;
    outcomeName: string;
    public oldControlValue: string;
    public newControlValue: string;
    private _shouldBreakDown: boolean;

    public get shouldBreakDown(): boolean {
        return this._shouldBreakDown;
    }

    public set shouldBreakDown(value: boolean) {
        const wasBreakDown = this._shouldBreakDown;
        this._shouldBreakDown = value;
        
        // If shouldBreakDown just became true and component is active, trigger scroll
        if (value && !wasBreakDown && this.isActive()) {
            setTimeout(() => {
                this.scrollToSelectedColumnIfReady();
            }, 0);
        }
    }

    loading = false;
    dataLoaded = false;

    constructor(private dataService: DataService, private activatedRoute: ActivatedRoute,
        private router: Router, projectService: ProjectService, columnScrollService: ColumnScrollService) {
        super(projectService, columnScrollService);
    }

    public async loadDataInternal(): Promise<void> {
        const resp = await this.dataService.get<ExistenceSettings>('columnSelection/existence/' + this.projectId);
        this.stepState = resp.stepState;
        this.shouldBreakDown = resp.shouldBreakDown;
        this.columns = resp.columns;
        this.outcomeName = resp.outcomeName;
        this.oldControlValue = resp.oldControlValue;
        this.newControlValue = resp.newControlValue;
        super.selectColumn(resp.columns.filter(c => c.isSelected)[0]);
        this.dataLoaded = true;
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    // Override the base scrolling logic to only scroll when table is visible
    protected override scrollToSelectedColumnIfReady(): void {
        // Only scroll if component is active, shouldBreakDown is true (table is visible), and we have the scroll service
        if (!this.isActive() || !this.shouldBreakDown || !this.columnScrollService) {
            return;
        }
        
        if (this.tableContainer && this.columns) {
            this.columnScrollService.scrollToSelectedColumn(this.tableContainer, this.columns);
        }
    }

    async save() {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            const changesApplied = await this.dataService.post<boolean>('columnSelection/existence', {
                projectId: this.projectId,
                columnIndex: this.columns.indexOf(this.selectedColumn),
                shouldBreakDown: this.shouldBreakDown
            });
            this.finishStepSuccessfully(changesApplied);
        } finally {
            this.loading = false;
        }
    }
}
